const PyramidSVG = () => {
  return (
    <svg
      height="85%"
      width="85%"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 20 512 512">
      <g transform="translate(-1)">
        <g>
          <g>
            <path
              d="M511.717,490.424l-85.333-136.533c-1.559-2.495-4.294-4.011-7.236-4.011H94.88c-2.942,0-5.677,1.516-7.236,4.011
				L2.311,490.424c-3.552,5.684,0.534,13.056,7.236,13.056H504.48C511.183,503.48,515.269,496.108,511.717,490.424z M24.943,486.414
				L99.61,366.947h314.807l74.667,119.467H24.943z"
              //   stroke="white"
              //   stroke-width="20"

              className="fill-neutralLight stroke-[8px] stroke-neutralLight"
            />
            <path
              d="M188.747,179.214c-2.942,0-5.677,1.516-7.236,4.011L96.177,319.758c-3.552,5.684,0.534,13.056,7.236,13.056h307.2
				c6.702,0,10.789-7.372,7.236-13.056l-45.173-72.277h73.146c3.789,14.723,17.152,25.6,33.058,25.6
				c18.853,0,34.133-15.281,34.133-34.133s-15.281-34.133-34.133-34.133c-15.906,0-29.269,10.877-33.058,25.6H362.01l-29.493-47.189
				c-1.559-2.495-4.294-4.011-7.236-4.011H188.747z M478.88,221.88c9.427,0,17.067,7.64,17.067,17.067
				c0,9.427-7.64,17.067-17.067,17.067s-17.067-7.64-17.067-17.067C461.814,229.52,469.453,221.88,478.88,221.88z M395.217,315.747
				H118.81l74.667-119.467h127.074L395.217,315.747z"
              className="fill-neutralLight stroke-[8px] stroke-neutralLight"
            />
            <path
              d="M94.88,145.08c15.906,0,29.269-10.877,33.058-25.6h74.961l-13.437,30.713c-2.467,5.638,1.664,11.954,7.818,11.954
				h119.467c6.154,0,10.284-6.316,7.818-11.954L264.832,13.66c-2.983-6.817-12.653-6.817-15.636,0l-38.83,88.754h-82.428
				c-3.789-14.723-17.152-25.6-33.058-25.6c-18.853,0-34.133,15.281-34.133,34.133C60.747,129.8,76.028,145.08,94.88,145.08z
				 M257.014,38.37l46.686,106.71h-93.371L257.014,38.37z M94.88,93.88c9.427,0,17.067,7.64,17.067,17.067
				c0,9.427-7.64,17.067-17.067,17.067c-9.427,0-17.067-7.64-17.067-17.067C77.814,101.52,85.453,93.88,94.88,93.88z"
              className="fill-neutralLight stroke-[8px] stroke-neutralLight"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default PyramidSVG;
